import useGetIsReportTagsTooBig from './useGetIsReportTagsTooBig';
import { getInlineLabelComponents } from './utils';
import { View } from 'foundations-components/transitional/components/View';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getInlineLabelsItems = (config, inlineLabelTypes, reportResolveData, report, useInlineLabels) => {
  const inlineLabelsList = getInlineLabelComponents(inlineLabelTypes, useInlineLabels);
  return inlineLabelsList.filter(({
    condition
  }) => condition({
    config,
    reportResolveData,
    report
  })).map(({
    render: Label
  }, index) => /*#__PURE__*/_jsx(View, {
    marginInlineStart: index === 0 ? '0' : '200',
    marginInlineEnd: "100",
    as: "span",
    children: /*#__PURE__*/_jsx(Label, {
      config: config,
      reportResolveData: reportResolveData,
      report: report
    })
  }, index));
};
const ReportTagsWrapper = ({
  isMobile,
  refHandler,
  overrideTooltip,
  children,
  customSubheader,
  containerRef
}) => {
  return /*#__PURE__*/_jsxs(TFlex, {
    "data-test-id": "report-subheader",
    alignItems: "baseline",
    overflowX: "clip",
    flexGrow: 0,
    ref: containerRef,
    children: [/*#__PURE__*/_jsxs(View, {
      marginInlineEnd: "300",
      marginBlockEnd: isMobile ? '0' : '500',
      paddingInlineStart: isMobile ? '400' : '0',
      display: "inline-block",
      ref: refHandler,
      children: [overrideTooltip, /*#__PURE__*/_jsx(Text, {
        whiteSpace: "nowrap",
        display: "inline-block",
        children: children
      })]
    }), customSubheader]
  });
};
export const InlineLabels = ({
  config,
  containerWidth,
  overrideTooltip,
  isMobile = false,
  inlineLabelTypes,
  customSubheader,
  containerRef,
  reportResolveData,
  report,
  useInlineLabels = true
}) => {
  const {
    isFirstReportTagTooBig,
    isAllReportTagsTooBig,
    allReportTagsRef,
    firstReportTagRef
  } = useGetIsReportTagsTooBig(containerWidth);
  const inlineLabelItems = getInlineLabelsItems(config, inlineLabelTypes, reportResolveData, report, useInlineLabels);
  if (inlineLabelItems.length === 0 || isAllReportTagsTooBig && isFirstReportTagTooBig) {
    return null;
  } else if (isAllReportTagsTooBig && !isFirstReportTagTooBig) {
    return /*#__PURE__*/_jsx(ReportTagsWrapper, {
      isMobile: isMobile,
      refHandler: firstReportTagRef,
      overrideTooltip: overrideTooltip,
      customSubheader: customSubheader,
      containerRef: containerRef,
      children: inlineLabelItems[0]
    });
  }
  return /*#__PURE__*/_jsx(ReportTagsWrapper, {
    isMobile: isMobile,
    refHandler: allReportTagsRef,
    overrideTooltip: overrideTooltip,
    customSubheader: customSubheader,
    containerRef: containerRef,
    children: inlineLabelItems
  });
};